<template>
  <div>
    <div @click="$emit('close', 'close')" class="back" style="border:.0rem">
      <v-icon style="color:var(--button-color);" size="24"
        >keyboard_arrow_left</v-icon
      >Back
    </div>
    <div class="job-preview">
      <div class="row preview-content-top">
        <div class="col-12 company-logo">
          <img :src="src" class="image" />
        </div>
        <div class="col-12 no-padding">
          <div class="job-title">{{ name }}</div>
          <div class="company-name">{{ headerPosition }}</div>
          <div class="company-email">{{ location }}</div>
        </div>
        <!--<div class="col-3 col-md-3 col-lg-3 col-xl-3 no-padding">-->
        <!--<div class="row button-margin">-->
        <!--<div class="col-6 col-md-6 col-lg-6 col-xl-6">-->
        <!--<div class="button">-->
        <!--<v-icon color="white">grade</v-icon>-->
        <!--<span style="padding-left:.5rem">Favorite</span>-->
        <!--</div>-->
        <!--</div>-->
        <!--<div class="col-6 col-md-6 col-lg-6 col-xl-6">-->
        <!--<div class="button">-->
        <!--<v-icon color="white" size="14">chat</v-icon>-->
        <!--<span style="padding-left:.5rem">Contact</span>-->
        <!--</div>-->
        <!--</div>-->
        <!--</div>-->
        <!--</div>-->
      </div>
      <div v-if="experiences.length > 0" class="content">
        <div class="title-head">Experiences</div>
        <div v-for="(experience, index) in experiences" :key="index">
          <experience
            :exp="experience"
            :end="experiences.length === index + 1"
          ></experience>
        </div>
      </div>
      <div v-if="educations.length > 0" class="content">
        <div class="title-head">Educations</div>
        <div v-for="(education, index) in educations" :key="index">
          <education
            :edu="education"
            :end="educations.length === index + 1"
          ></education>
        </div>
      </div>
      <div v-if="skills.length > 0" class="content" align="left">
        <div class="title-head">Skills</div>
        <div class="skill-padding">
          <span :key="index" v-for="(skill, index) in skills">
            <span class="text-left">
              {{ skill.skill_name
              }}{{ skills.length === index + 1 ? "." : ", " }}
            </span>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as FILTERS from "../../../filters";
import Experience from "./experience";
import Education from "./education";
export default {
  name: "phone-profile",
  components: {
    Experience,
    Education
  },
  props: {
    candidate: Object
  },
  data: function() {
    return {
      test: true,
      name: null,
      gender: null,
      location: null,
      educations: [],
      experiences: [],
      skills: [],
      headerPosition: "",
      src: require("@/assets/male_user.svg")
    };
  },
  methods: {
    loadData() {
      const self = this;
      //   self.candidate = this.$route.params.details;
      if (self.candidate) {
        self.name = FILTERS.FIRST_LETTER_CAPITAL(self.candidate.user_name);
        self.gender = self.candidate.gender
          ? FILTERS.FIRST_LETTER_CAPITAL(self.candidate.gender)
          : null;
        self.src = self.candidate.image_url
          ? self.candidate.image_url
          : self.src;
        if (self.gender === "female") {
          self.src = self.candidate.image_url
            ? self.candidate.image_url
            : require("@/assets/female_user.svg");
        } else {
          self.src = self.candidate.image_url
            ? self.candidate.image_url
            : require("@/assets/male_user.svg");
        }
        self.location = self.candidate.location_name
          ? FILTERS.FIRST_LETTER_CAPITAL(self.candidate.location_name)
          : null;
        self.educations = self.candidate.education
          ? self.candidate.education
          : [];
        self.experiences = self.candidate.experience
          ? self.candidate.experience
          : [];
        self.skills = self.candidate.skill ? self.candidate.skill : "";
        for (let key in self.experiences) {
          if (self.experiences[key].is_working === 1)
            self.headerPosition = self.experiences[key].position;
        }
      }
    }
  },
  mounted() {
    this.loadData();
  }
};
</script>

<style scoped>
.image {
  margin: 0rem 2rem 2rem 2rem;
  height: 35vw;
  width: 35vw;
  border-radius: 50%;
}
.job-preview {
  padding: 0rem 1.5rem;
}
.preview-content-top {
  padding: 1rem 0 1rem 0;
  padding-right: 0rem !important;
}
.job-details-in-short {
  padding: 0;
  margin-left: -1.5rem;
}
.job-title {
  font-size: 2rem;
  font-weight: bold;
  padding-bottom: 0.2rem;
  text-align: center;
}
.company-name {
  font-size: 1.4rem;
  font-weight: bold;
  text-align: center;
}
.company-email {
  font-size: 1.4rem;
  text-align: center;
}
.title-head {
  font-size: 1.8rem;
  font-weight: 400;
  padding: 1rem 0;
  text-align: left;
  border-bottom: 0.1rem solid #f0f0f0;
}
.content {
  text-align: left;
  border-bottom: 0.1rem solid #f0f0f0;
}
.button {
  background-color: #11998e;
  color: white;
  padding: 0.5rem;
  cursor: pointer;
}
.button-margin {
  margin-top: 4.5rem !important;
  margin-right: -7rem !important;
}
.no-border {
  border: 0rem;
}
.skill-padding {
  padding: 1rem;
}
</style>
